const isDevelopment = process.env.NODE_ENV === "development";
const config = {
  backendUrl: !isDevelopment ? "https://vestr.io:3001" : "http://localhost:3001",
  socketUrl: !isDevelopment ? "wss://vestr.io:3001" : "ws://localhost:3001",
  LBbackendUrl: "https://leaderboard.vestr.io:3001", // Leaderboard page backend URL
  PortfolioBackendUrl: "https://portfolio.vestr.io:3001", // Portfolio page backend URL
};

export default config;